export default "__VITE_ASSET__DX5KfWTm__"